import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
export const FigmaRecentIcon = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsxs("svg", {
        ref: ref,
        ...props,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("g", {
                "clip-path": "url(#a)",
                children: /*#__PURE__*/ _jsx("path", {
                    fill: "currentColor",
                    d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7 4V8.5V9H7.5H12V8H8V4H7Z",
                    clipRule: "evenodd",
                    fillRule: "evenodd"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "currentColor"
                    })
                })
            })
        ]
    }));
FigmaRecentIcon.displayName = "FigmaRecentIcon";
